import { Component, Input, OnInit } from '@angular/core';
import { PromoService } from '../../services/promo.service';
import { Promo } from '../../interfaces/Promo';

@Component({
  selector: 'ng-promo-establishment',
  styleUrls: ['./promo-establishment.component.css'],
  template: `
    <div class="promo-container" *ngIf="canParticipate()">
      <div *ngFor="let promo of promos">
        <h3>Promoção</h3>
        <ng-promo-details
            [promo]="promo"
            [showImage]="false">
        </ng-promo-details>
      </div>
    </div>
  `
})
export class PromoEstablishmentComponent implements OnInit {

  @Input() set establishmentId(id) {
    this.getPromos(id);
  }

  promos: Promo[] = [];

  constructor(private promoService: PromoService) { }

  ngOnInit() {}

  getPromos(establishmentId) {
    this.promoService
      .getActivePromos()
      .subscribe(promos => {
        this.promos = promos.filter(promo => establishmentId === promo.establishmentId);
      }, err => {
        console.warn('Não foi possível recuperar a lista de promoções. Err:', err);
      });
  }

  canParticipate() {
    return this.promoService.canParticipate();
  }

}
